import { LOCALES } from "~/constants/i18n";

import { AzureConfigurator } from "../azure-configurator/azure-configurator";

export const getClientId = (locale: LOCALES): string | undefined =>
  AzureConfigurator.getConfig(locale)?.azure?.adB2C?.clientId;
